export default "/_next/static/f4033b1eba1124e56ec0c8a582014d3f.png";